$(document).ready(function () {

    'use-strict';

    $.extend({
        YoutubeImage: function (url) {
            if (url === null || url === undefined) { return ""; }

            var vid;
            var results;

            results = url.match("[\?&]v=([^&#]*)");

            vid = (results === null) ? url : results[1];

            return 'https://i3.ytimg.com/vi/' + vid + '/maxresdefault.jpg';
        }
    });

    var iframes = document.querySelectorAll('.ratio');

    if (iframes) {
        iframes.forEach(iframe => {

            let overlay = iframe.querySelector('.video-overlay');
            let frame = iframe.querySelector('iframe');

            if (!frame || !overlay) { return; }

            // Flags the player as running so styling can stop clipping the corners: the
            // player's own controls sit there and have to stay visible and clickable.
            let showPlayer = function () {
                overlay.style.display = 'none';
                iframe.classList.add('is-playing');
                // The play button is what had focus and it is now hidden, so hand focus to
                // the player instead of dropping it back to the top of the document.
                frame.focus();
            };

            overlay.addEventListener('click', function () {
                frame.src = frame.src + '?autoplay=1';
                showPlayer();
            })

            frame.onplay = showPlayer;
        })
    }
});
